import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import clsx from 'clsx';

import close_img from '../../assets/close.svg';

import './styles.css';

const Modal = (props) => {
  const {
    isOpen = true,
    canClose = false,
    isVisibleCloseIcon = true,
    onClose = () => { },
    children,
    className = '',
    withBlurBackground = true
  } = props;

  const handleClose = () => {
    onClose();
    return;
  };

  const handleEsc = event => {
    if (canClose && event.key === 'Escape') {
      handleClose();
    }
  };

  const handleOverlayClick = e => {
    if (e.target.classList.contains('modal-overlay')) {
      handleClose();
    }
  };

  useEffect(() => {
    if (isOpen) {
      const originalPaddingRight = document.body.style.paddingRight;
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

      document.body.style.paddingRight = `${scrollbarWidth}px`;
      document.body.style.overflow = 'hidden';

      window.addEventListener('keydown', handleEsc);
      return () => {
        window.removeEventListener('keydown', handleEsc);
        document.body.style.overflow = 'auto';
        document.body.style.paddingRight = originalPaddingRight;
      };
    }
  }, [isOpen]);

  if (!isOpen) {
    return;
  }

  return ReactDOM.createPortal(
    <div className={clsx('modal-overlay', { 'no-blur': !withBlurBackground })} onClick={handleOverlayClick}>
      <div className={clsx('modal', className)}>
        {canClose && isVisibleCloseIcon && <img src={close_img} className="modal-close-icon" onClick={handleClose} />}
        <div className="modal-content">{children}</div>
      </div>
    </div>,
    document.body
  );
};

export default Modal;
